import { combineReducers } from "@reduxjs/toolkit";

import { AuthReducer } from "./AuthReducer";
import { ResearchReducer } from "./ResearchReducer";
import { LoadingReducer } from "./LoadingReducer";
import { ProjectReducer } from "./ProjectReducer";
import { EventReducer } from "./EventReducer";
import { TeamReducer } from "./TeamReducer";
import { CollaborationReducer } from "./CollaborationReducer";
import { KnowledgeRepositoryReducer } from "./KnowledgeRepositoryReducer";
import { BannerReducer } from "./BannerReducer";
import { TrainingReducer } from "./TrainingReducer";
import { VacanciesReducer } from "./VacanciesReducer";
import { AnnouncementReducer } from "./AnnouncementReducer";

export default combineReducers({
    AuthReducer,
    ResearchReducer,
    LoadingReducer,
    ProjectReducer,
    EventReducer,
    TeamReducer,
    CollaborationReducer,
    KnowledgeRepositoryReducer,
    BannerReducer,
    TrainingReducer,
    VacanciesReducer,
    AnnouncementReducer,
});